<template>
  <div class="container mt-4">
    <h2>Geplante E-Mails</h2>
    
    <b-alert v-if="message" variant="info" dismissible>{{ message }}</b-alert>

    <div v-if="loading" class="text-center my-5">
      <b-spinner label="Lade E-Mails..." />
    </div>

    <b-table v-else :items="mails" :fields="fields" striped hover responsive>
      <template #cell(sendAt)="row">
        {{ formatDate(row.item.sendAt) }}
      </template>
      <template #cell(actions)="row">
        <b-button size="sm" variant="danger" v-b-modal.delete-mail-modal @click="selectedMail = row.item.id">Löschen</b-button>
      </template>
    </b-table>
    <b-modal id="delete-mail-modal" title="Löschen?" @ok="deleteMail(selectedMail)">
      <p class="my-4">Möchtest du diese E-Mail wirklich löschen?</p>
    </b-modal>
  </div>
</template>

<script>
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore'
import { firestore } from '../plugins/firebase'
import moment from 'moment'

export default {
  data() {
    return {
      selectedMail: null,
      mails: [],
      loading: false,
      message: null,
      fields: [
        { key: 'to', label: 'Empfänger' },
        { key: 'subject', label: 'Betreff' },
        { key: 'sendAt', label: 'Geplant für' },
        { key: 'actions', label: '', class: 'text-right' },
      ]
    }
  },
  methods: {
    async loadMails() {
      this.loading = true;
      const querySnapshot = await getDocs(collection(firestore, 'delayedEmails'));
      this.mails = querySnapshot.docs.map(docSnap => ({
        id: docSnap.id,
        ...docSnap.data()
      }));
      this.loading = false;
    },
    formatDate(date) {
      if (date?.toDate) {
        return moment(date.toDate()).format('DD.MM.YYYY HH:mm');
      } else if (typeof date === 'string') {
        return date;
      }
      return '-';
    },
    async deleteMail(id) {
      try {
        await deleteDoc(doc(firestore, 'delayedEmails', id));
        this.message = 'E-Mail wurde gelöscht.';
        this.loadMails();
      } catch (err) {
        this.message = 'Fehler beim Löschen: ' + err.message;
      }
      this.selectedMail = null;
      setTimeout(() => this.message = null, 3000);
    }
  },
  mounted() {
    this.loadMails();
  }
}
</script>

<style scoped>
.container {
  max-width: 900px;
}
</style>
